class ArticleContent extends HTMLElement {
  constructor() {
    super();
    this.initializeBeforeAndAfters();
    this.initializeZoomButtons();
  }

  initializeBeforeAndAfters() {
    const className = 'before-and-after';
    const sliderClass = `${className}--slider`;
    const dividerClass = `${className}--divider`;
    const handleClass = `${className}--handle`;

    const allBeforeAndAfters = Array.from(this.querySelectorAll(`.${className}`));
    allBeforeAndAfters.forEach((beforeAndAfter) => {
      const before = beforeAndAfter.querySelector('& > .component-image:first-child');
      const after = beforeAndAfter.querySelector('& > .component-image:nth-child(2');
      let slider = beforeAndAfter.querySelector(`.${sliderClass}`);
      let divider = beforeAndAfter.querySelector(`.${dividerClass}`);
      let handle = beforeAndAfter.querySelector(`.${handleClass}`);

      if (!before || !after) {
        return;
      }
      if (slider || divider || handle) {
        return;
      }

      divider = document.createElement('div');
      divider.classList.add(dividerClass);
      divider.innerHTML = ' ';
      beforeAndAfter.appendChild(divider);

      handle = document.createElement('div');
      handle.classList.add(handleClass);
      handle.innerHTML = ' ';
      beforeAndAfter.appendChild(handle);

      slider = document.createElement('input');
      slider.classList.add(sliderClass);
      slider.type = 'range';
      slider.min = '0';
      slider.max = '100';
      slider.step = '';

      beforeAndAfter.appendChild(slider);

      slider.addEventListener('input', (e) => {
        const percentage = Number(e.target.value);
        divider.style.left = `calc(${percentage}% - 2px)`;
        handle.style.left = `calc(${percentage}% - 25px)`;
        after.style.clipPath = `rect(0% 100% 100% ${percentage}%)`;
      });
    });
  }

  initializeZoomButtons() {
    const overlayClass = `component-image--zoom-overlay`;
    const buttonClass = `component-image--zoom-button`;
    const modalImageClass = '.article-zoom-modal .article-zoom-modal__content .article-zoom-modal__content-media img';
    const media = document.querySelector(modalImageClass);

    subscribe(PUB_SUB_EVENTS.modalDialogClose, ({ modal }) => {
      if (modal === 'PopupModal-ArticleZoom') {
        media.src = '';
      }
    });

    const allArticleImage = Array.from(this.querySelectorAll(`.component-image`));
    allArticleImage.forEach((image) => {
      if (image.closest('.before-and-after') || image.firstChild.nodeName == 'A') {
        return;
      }

      [overlayClass, buttonClass].forEach((className) => {
        let zoomButton = image.querySelector(`.${className}`);
        if (zoomButton) {
          return;
        }

        const modalOpener = document.createElement('modal-opener');
        modalOpener.dataset.modal = '#PopupModal-ArticleZoom';

        zoomButton = document.createElement('button');
        zoomButton.classList.add(className);
        zoomButton.type = 'button';
        zoomButton['aria-haspopup'] = 'dialog';

        if (className === overlayClass) {
          zoomButton.tabIndex = -1;
          zoomButton.innerHTML = ' ';
        } else {
          zoomButton.innerHTML = `<svg aria-hidden="true" width="22" height="22" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><g transform="rotate(45 16 16)"><path d="M24 24L8 8" stroke="currentColor" stroke-width="2"></path><path d="M24 8L8 24" stroke="currentColor" stroke-width="2"></path></g></svg>`;
        }

        zoomButton.addEventListener('click', () => {
          const img = image.querySelector('img');
          media.src = img.src;
          media.height = img.height;
          media.width = img.width;
        });

        modalOpener.appendChild(zoomButton);

        modalOpener.init();
        image.appendChild(modalOpener);
      });
    });
  }
}
customElements.define('article-content', ArticleContent);
